import React from "react";
import styles from './faq.module.css';

export default function Faq() {
  return (
    <div id="faq" className={styles.faqSection}>
      <div className={styles.faqHeading}>
        <h1>Get Answers to your questions hear!</h1>
        <h2>
          Can’t find answers? <a href="tel:+91 8951092604"><p>Connect with us now.</p> </a>
        </h2>
      </div>
      <div className={styles.QandA}>
        <h2>How Farmers can sell their products to Adaya? </h2>
        <p>
          It’s simple. You can call us at <a href="tel:+91 89510 92635">+91 89510 92635</a>,
          <a href="tel:+91 89510 92604"> +91 89510 92604</a> and our
          team will get in touch with you and assist you further.
        </p>
      </div>

      <div className={styles.QandA}>
        <h2>Does Adaya charge transportation cost for farmers?</h2>
        <p>No, We do not charge any additional costs from farmers.</p>
      </div>

      <div className={styles.QandA}>
        <h2>How can I make payment for my order?</h2>
        <p>
          You can pay via online payment methods or pay by cash to our agent
          after receiving your order in hand.
        </p>
      </div>

      <div className={styles.QandA}>
        <h2>Can i become Adaya’s daily customer?</h2>
        <p>
          Yes, you can become our daily customer once physically verified by our
          agent on our first day of order delivery.
        </p>
      </div>

      <div className={styles.QandA}>
        <h2>Is there a delivery charge for retailers and consumers?</h2>
        <p>Yes, you will be charged Rs. xx for the orders above Rs. xxx</p>
      </div>
    </div>
  );
}